import React from 'react';
import './Contact.css'; 

const Map = () => (
  <div className="contact-map">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.8781973350024!2d6.830034038560213!3d49.41819521008005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4795a3e34d018625%3A0x9b20c69ff595f4c5!2sGr%C3%BCbchenstra%C3%9Fe%2048%2C%2066839%20Schmelz%2C%20Germany!5e0!3m2!1sen!2ses!4v1693927275440!5m2!1sen!2ses"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Google Maps Location"
    ></iframe>
  </div>
);

export default Map;
